import createDebug from 'debug';
/**
 * Debug instance with the given namespace: http-proxy-middleware
 */
export const Debug = createDebug('http-proxy-middleware');
